import { commonRequestData, fetchData } from "../../api";

export const traerTodosLosArticulos = async ({ estado }) => {
    // Prepara los datos para la solicitud, combinando datos comunes con parámetros específicos
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., encabezados, token)
        estado, // Parámetro específico para filtrar por estado
    };

    // Llama a la API usando fetchData para obtener la lista de artículos desde el endpoint "/lista"
    const response = await fetchData("articulos/lista", requestData);

    // Devuelve la respuesta obtenida, que contiene la lista de artículos
    return response;
};

export const traerTodosLosArticulosSegunGrupo = async ({ estado, grupo }) => {
    // Prepara los datos para la solicitud, combinando datos comunes con parámetros específicos
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., encabezados, token)
        estado,
        grupo,
    };

    // Llama a la API usando fetchData para obtener la lista de artículos desde el endpoint "/lista"
    const response = await fetchData("articulos/extraerSegunElgrupo", requestData);

    // Devuelve la respuesta obtenida, que contiene la lista de artículos
    return response;
};



/**
 * Envía una solicitud para crear un nuevo artículo utilizando los datos proporcionados.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {Object} params.formData - Datos del formulario para crear el artículo.
 * @returns {Promise<Object>} La respuesta de la API con los detalles del artículo creado.
 */
export const fetchcrearArticulo = async ({ formData }) => {
    // Combina los datos comunes necesarios para la solicitud con los datos del formulario.
    const requestData = {
        ...commonRequestData, // Datos comunes para la solicitud.
        formData, // Datos del formulario para crear el artículo.
    };

    // Realiza una solicitud a la API para crear un nuevo artículo.
    // Utiliza el endpoint "admins/crear" para registrar el nuevo artículo.
    const response = await fetchData("articulos/crear", requestData);

    // Retorna la respuesta obtenida de la API.
    return response;
};


export const fetcheditarArticulo = async ({ formData }) => {
    // Combina los datos comunes necesarios para la solicitud con los datos del formulario.
    const requestData = {
        ...commonRequestData, // Datos comunes para la solicitud.
        formData, // Datos del formulario para crear el artículo.
    };

    // Realiza una solicitud a la API para crear un nuevo artículo.
    // Utiliza el endpoint "admins/crear" para registrar el nuevo artículo.
    const response = await fetchData("articulos/editar", requestData);

    // Retorna la respuesta obtenida de la API.
    return response;
};

export const fetchExtraerArticulo = async ({ idArticulo }) => {
    // Prepara los datos necesarios para realizar la solicitud a la API.
    const requestData = {
        ...commonRequestData, // Incluye datos comunes requeridos para todas las solicitudes.
        idArticulo, // Agrega el ID del artículo que se desea extraer.
    };

    // Realiza una solicitud a la API para obtener información sobre un artículo específico.
    // Se utiliza el endpoint "articulos/exatrerArticulo" para recuperar los datos del artículo.
    const response = await fetchData("articulos/exatrerArticulo", requestData);

    // Devuelve la respuesta obtenida de la API.
    return response;
};
